import { render, staticRenderFns } from "./WlConfig.vue?vue&type=template&id=141652d0&scoped=true&"
import script from "./WlConfig.vue?vue&type=script&lang=js&"
export * from "./WlConfig.vue?vue&type=script&lang=js&"
import style0 from "./WlConfig.vue?vue&type=style&index=0&id=141652d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141652d0",
  null
  
)

export default component.exports